/**
 * Vergleichsportal (/vergleich, /vergleich/ergebnis).
 *
 * Reine Komfortschicht: Flaeche live anzeigen, Auswahl der Betriebe zaehlen und
 * auf das Maximum begrenzen, Button-Text anpassen. Ohne JavaScript funktioniert
 * alles ueber den Server, der dieselben Grenzen prueft.
 */

function zahlAus(roh: string): number | null {
  const n = Number(roh.trim().replace(",", "."));
  return Number.isFinite(n) && n > 0 ? n : null;
}

function initFlaeche(): void {
  const form = document.querySelector<HTMLFormElement>("[data-vg-projekt]");
  const ausgabe = form?.querySelector<HTMLOutputElement>("[data-vg-flaeche]");
  if (!form || !ausgabe) return;
  const felder = Array.from(form.querySelectorAll<HTMLInputElement>("[data-vg-mass]"));
  const vorlage = ausgabe.dataset["vorlage"] ?? "# m²";
  const format = new Intl.NumberFormat(document.documentElement.lang || "de", { maximumFractionDigits: 1 });
  const rechne = (): void => {
    const [b, t] = felder.map((f) => zahlAus(f.value));
    ausgabe.textContent = b && t ? vorlage.replace("#", format.format(b * t)) : "";
  };
  for (const f of felder) f.addEventListener("input", rechne);
  rechne();
}

function initAuswahl(): void {
  const form = document.querySelector<HTMLFormElement>("[data-vg-anfrage]");
  const zaehler = form?.querySelector<HTMLElement>("[data-vg-zaehler]");
  const knopf = form?.querySelector<HTMLButtonElement>("[data-vg-senden]");
  if (!form || !zaehler || !knopf) return;
  const max = Number(zaehler.dataset["max"]) || 3;
  const boxen = Array.from(form.querySelectorAll<HTMLInputElement>("[data-vg-partner]"));
  // data-text-1 -> "text-1", data-text-n -> "textN", data-auswahl-0 -> "auswahl-0"
  const d = knopf.dataset;

  const aktualisiere = (): void => {
    const n = boxen.filter((b) => b.checked).length;
    for (const b of boxen) {
      const karte = b.closest(".vg-partner");
      b.disabled = !b.checked && n >= max;
      karte?.classList.toggle("ist-gewaehlt", b.checked);
      karte?.classList.toggle("ist-gesperrt", b.disabled);
    }
    const auswahl = n === 0 ? d["auswahl-0"] : n === 1 ? d["auswahl-1"] : d["auswahlN"]?.replace("#", String(n));
    const text = n === 0 ? d["textKeiner"] : n === 1 ? d["text-1"] : d["textN"]?.replace("#", String(n));
    if (auswahl) zaehler.textContent = auswahl;
    if (text) knopf.textContent = text;
  };
  for (const b of boxen) b.addEventListener("change", aktualisiere);
  aktualisiere();
}

initFlaeche();
initAuswahl();
